import React from 'react';
import { motion } from 'framer-motion';

export interface TutorialSlide {
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface TutorialSlideProps {
  slide: TutorialSlide;
}

const TutorialSlideComponent: React.FC<TutorialSlideProps> = ({ slide }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ 
        duration: 0.5,
        ease: "easeOut"
      }}
      className="space-y-4 max-w-xs w-full flex flex-col items-center"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="flex justify-center w-full"
      >
        {slide.icon}
      </motion.div>
      
      <motion.h2 
        className="text-xl font-bold"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        {slide.title}
      </motion.h2>
      
      <motion.p 
        className="text-muted-foreground"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        {slide.description}
      </motion.p>
    </motion.div>
  );
};

export default TutorialSlideComponent;
